import { Component, Input, OnInit } from '@angular/core';
import { IModalGarbageModel } from '@types-custom/models/ui/modal-garbage-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';
import { Icon } from '@types-custom/models/ui/icon-model';

/*
 ** Modal Garbage
 ** Render a modal that displays information about garbage containers.
 */

@Component({
  selector: 'citizen-modal-garbage',
  templateUrl: './modal-garbage.component.html',
  styleUrls: ['./modal-garbage.component.scss'],
})
export class ModalGarbageComponent implements OnInit {
  @Input() properties: IModalGarbageModel | undefined;
  Icon = Icon;

  constructor(private drawerPanelService: DrawerPanelService) {}

  ngOnInit(): void {
    this.drawerPanelService.collapseDrawer(true);
  }

  getFillColor(percentage: number): string {
    if (percentage >= 70) {
      return '#e74c3c';
    } else if (percentage >= 40) {
      return '#f39c12';
    } else {
      return '#2ecc71';
    }
  }

  getPercentage(): number {
    return this.properties?.binFillingLevel ? +this.properties.binFillingLevel : 0;
  }

  getBinClearedTimeAsLocalDate(): Date | null {
    const value = this.properties?.binClearedTime;
    if (!value) {
      return null;
    }
    const normalized = value.endsWith('Z') ? value.slice(0, -1) : value;
    const date = new Date(normalized);
    return isNaN(date.getTime()) ? null : date;
  }
}

